module.exports = __webpack_public_path__ + "static/media/logo-xs.3addfe76.png";